export const AUTH_HANDOFF_REQUEST = 'BORA_AUTH_HANDOFF_REQUEST'
export const AUTH_HANDOFF_RESPONSE = 'BORA_AUTH_HANDOFF_RESPONSE'

const RESPONDER_TIMEOUT_MS = 10000

const isAuthRequest = (data) => Boolean(data && typeof data === 'object' && data.type === AUTH_HANDOFF_REQUEST)

export function openNewEditPageWithAuthToken({ path, sales2Origin, token }) {
  let targetOrigin
  let targetUrl

  try {
    targetOrigin = new URL(sales2Origin).origin
    targetUrl = new URL(path, `${targetOrigin}/`).toString()
  } catch (error) {
    return false
  }

  let childWindow = null
  let timeoutId

  let cleanup = () => {}

  const handleMessage = (event) => {
    if (event.origin !== targetOrigin || event.source !== childWindow || !isAuthRequest(event.data)) return

    childWindow.postMessage({ type: AUTH_HANDOFF_RESPONSE, token }, targetOrigin)
    cleanup()
  }

  cleanup = () => {
    window.clearTimeout(timeoutId)
    window.removeEventListener('message', handleMessage)
  }

  if (token) window.addEventListener('message', handleMessage)
  childWindow = window.open(targetUrl)

  if (!childWindow) {
    cleanup()
    window.location.assign(targetUrl)
    return true
  }

  if (token) timeoutId = window.setTimeout(cleanup, RESPONDER_TIMEOUT_MS)
  return true
}
